import { DateTime } from 'luxon';
// import env from '../../../../constants/env';

import AdultSilhouetteAnteriorJS from 			'../assets/images/canvas/adult/AdultSilhouetteAnterior.js';
import AdultSilhouettePosteriorJS from 			'../assets/images/canvas/adult/AdultSilhouettePosterior.js';
const AdultSilhouetteAnterior = 		require('../assets/images/canvas/adult/AdultSilhouetteAnterior.png');
const AdultSilhouettePosterior = 		require('../assets/images/canvas/adult/AdultSilhouettePosterior.png');
const AdultSilhouetteAnteriorOutline = 	require('../assets/images/canvas/adult/AdultSilhouetteAnteriorOutline.png');
const AdultSilhouettePosteriorOutline = require('../assets/images/canvas/adult/AdultSilhouettePosteriorOutline.png');
const AdultSilhouetteAnteriorFlip = 	require('../assets/images/canvas/adult/AdultSilhouetteAnteriorFlip.png');
const AdultSilhouettePosteriorFlip = 	require('../assets/images/canvas/adult/AdultSilhouettePosteriorFlip.png');

import ChildSilhouetteAnteriorJS from 			'../assets/images/canvas/child/ChildSilhouetteAnterior.js';
import ChildSilhouettePosteriorJS from 			'../assets/images/canvas/child/ChildSilhouettePosterior.js';
const ChildSilhouetteAnterior = 		require('../assets/images/canvas/child/ChildSilhouetteAnterior.png');
const ChildSilhouettePosterior = 		require('../assets/images/canvas/child/ChildSilhouettePosterior.png');
const ChildSilhouetteAnteriorOutline = 	require('../assets/images/canvas/child/ChildSilhouetteAnteriorOutline.png');
const ChildSilhouettePosteriorOutline = require('../assets/images/canvas/child/ChildSilhouettePosteriorOutline.png');
const ChildSilhouetteAnteriorFlip = 	require('../assets/images/canvas/child/ChildSilhouetteAnteriorFlip.png');
const ChildSilhouettePosteriorFlip = 	require('../assets/images/canvas/child/ChildSilhouettePosteriorFlip.png');

import InfantSilhouetteAnteriorJS from 			'../assets/images/canvas/infant/InfantSilhouetteAnterior.js';
import InfantSilhouettePosteriorJS from 		'../assets/images/canvas//infant/InfantSilhouettePosterior.js';
const InfantSilhouetteAnterior = 		require('../assets/images/canvas/infant/InfantSilhouetteAnterior.png');
const InfantSilhouettePosterior = 		require('../assets/images/canvas/infant/InfantSilhouettePosterior.png');
const InfantSilhouetteAnteriorOutline = require('../assets/images/canvas/infant/InfantSilhouetteAnteriorOutline.png');
const InfantSilhouettePosteriorOutline =require('../assets/images/canvas/infant/InfantSilhouettePosteriorOutline.png');
const InfantSilhouetteAnteriorFlip = 	require('../assets/images/canvas/infant/InfantSilhouetteAnteriorFlip.png');
const InfantSilhouettePosteriorFlip = 	require('../assets/images/canvas/infant/InfantSilhouettePosteriorFlip.png');


export const SILHOUETTE_TYPES = {
	base: 'base',
	baseB64: 'baseB64',
	outline: 'outline',
	flip: 'flip',
};
// const silhouettes = {
// 	adult: {
// 		front: {
// 			base: `${env.PUBLIC_S3_URL}/bodySites/canvas/adult/AdultSilhouetteAnterior.png`,
// 			baseB64: AdultSilhouetteAnterior,
// 			outline: `${env.PUBLIC_S3_URL}/bodySites/canvas/adult/AdultSilhouetteAnteriorOutline.png`,
// 			flip: `${env.PUBLIC_S3_URL}/bodySites/canvas/adult/AdultSilhouetteAnteriorFlip.png`,
// 		},
// 		back: {
// 			base: `${env.PUBLIC_S3_URL}/bodySites/canvas/adult/AdultSilhouettePosterior.png`,
// 			baseB64: AdultSilhouettePosterior,
// 			outline: `${env.PUBLIC_S3_URL}/bodySites/canvas/adult/AdultSilhouettePosteriorOutline.png`,
// 			flip: `${env.PUBLIC_S3_URL}/bodySites/canvas/adult/AdultSilhouettePosteriorFlip.png`,
// 		}
// 	},
// 	child: {
// 		front: {
// 			base: `${env.PUBLIC_S3_URL}/bodySites/canvas/child/ChildSilhouetteAnterior.png`,
// 			baseB64: ChildSilhouetteAnterior,
// 			outline: `${env.PUBLIC_S3_URL}/bodySites/canvas/child/ChildSilhouetteAnteriorOutline.png`,
// 			flip: `${env.PUBLIC_S3_URL}/bodySites/canvas/child/ChildSilhouetteAnteriorFlip.png`,
// 		},
// 		back: {
// 			base: `${env.PUBLIC_S3_URL}/bodySites/canvas/child/ChildSilhouettePosterior.png`,
// 			baseB64: ChildSilhouettePosterior,
// 			outline: `${env.PUBLIC_S3_URL}/bodySites/canvas/child/ChildSilhouettePosteriorOutline.png`,
// 			flip: `${env.PUBLIC_S3_URL}/bodySites/canvas/child/ChildSilhouettePosteriorFlip.png`,
// 		}
// 	},
// 	infant: {
// 		front: {
// 			base: `${env.PUBLIC_S3_URL}/bodySites/canvas/infant/InfantSilhouetteAnterior.png`,
// 			baseB64: InfantSilhouetteAnterior,
// 			outline: `${env.PUBLIC_S3_URL}/bodySites/canvas/infant/InfantSilhouetteAnteriorOutline.png`,
// 			flip: `${env.PUBLIC_S3_URL}/bodySites/canvas/infant/InfantSilhouetteAnteriorFlip.png`,
// 		},
// 		back: {
// 			base: `${env.PUBLIC_S3_URL}/bodySites/canvas/infant/InfantSilhouettePosterior.png`,
// 			baseB64: InfantSilhouettePosterior,
// 			outline: `${env.PUBLIC_S3_URL}/bodySites/canvas/infant/InfantSilhouettePosteriorOutline.png`,
// 			flip: `${env.PUBLIC_S3_URL}/bodySites/canvas/infant/InfantSilhouettePosteriorFlip.png`,
// 		}
// 	},
// };

const silhouettes = {
	adult: {
		front: {
			base: AdultSilhouetteAnterior,
			baseB64: AdultSilhouetteAnteriorJS,
			outline: AdultSilhouetteAnteriorOutline,
			flip: AdultSilhouetteAnteriorFlip,
		},
		back: {
			base: AdultSilhouettePosterior,
			baseB64: AdultSilhouettePosteriorJS,
			outline: AdultSilhouettePosteriorOutline,
			flip: AdultSilhouettePosteriorFlip,
		}
	},
	child: {
		front: {
			base: ChildSilhouetteAnterior,
			baseB64: ChildSilhouetteAnteriorJS,
			outline: ChildSilhouetteAnteriorOutline,
			flip: ChildSilhouetteAnteriorFlip,
		},
		back: {
			base: ChildSilhouettePosterior,
			baseB64: ChildSilhouettePosteriorJS,
			outline: ChildSilhouettePosteriorOutline,
			flip: ChildSilhouettePosteriorFlip,
		}
	},
	infant: {
		front: {
			base: InfantSilhouetteAnterior,
			baseB64: InfantSilhouetteAnteriorJS,
			outline: InfantSilhouetteAnteriorOutline,
			flip: InfantSilhouetteAnteriorFlip,
		},
		back: {
			base: InfantSilhouettePosterior,
			baseB64: InfantSilhouettePosteriorJS,
			outline: InfantSilhouettePosteriorOutline,
			flip: InfantSilhouettePosteriorFlip,
		}
	},
};

export const getAgeFromEocCondition = (eoc, condition) => {
	if (!eoc || !condition) return 0;
	return DateTime.fromISO(condition.onsetPeriodStart).diff(DateTime.fromISO(eoc.birthdate), 'years').years;
};

export const getSilhouette = (years, side, type) => {
	const ageRange = (years < 1) ? 'infant'
		: (years < 15) ? 'child'
			: 'adult';
	return silhouettes[ageRange][side][type];
};